class TogglesUtils {
    static calculateToggleId(toggle) {
        return toggle.name.replace(/\./g, "-");
    }
}


export default TogglesUtils;